import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VariableBenefitConfigurationSubmissionData } from '../../../../../../models/submissions/variable-benefit-configuration-submission-data';
import { WithdrawalInstruction } from '../../../../../../models/submissions/withdrawal-instruction';
import { FundType } from '../../../../../../models/transactions/fund-type';

@Component({
  selector: 'app-vb-config-withdrawal-instructions-review-card',
  templateUrl: './vb-config-withdrawal-instructions-review-card.component.html',
  styleUrls: ['./vb-config-withdrawal-instructions-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbConfigWithdrawalInstructionsReviewCardComponent implements OnChanges {
  @Input({ required: true }) submission!: VariableBenefitConfigurationSubmissionData;
  @Input() fundTypes: FundType[] = [];

  public activeInstructions: WithdrawalInstruction[] = [];

  public ngOnChanges(): void {
    const instructions = (this.submission?.withdrawalInstructions ?? []).filter(i => i.percentage > 0);
    this.activeInstructions = instructions.map(instruction =>
      Object.assign(new WithdrawalInstruction(), instruction, {
        fund: instruction.fund ?? this.fundTypes.find(f => f.id === instruction.fundId) ?? null!
      })
    );
  }
}
